import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import {
  DatePicker,
  Select,
  TreeSelect,
  Col,
  Space,
  Row,
  Button,
  Breadcrumb,
  Tabs,
} from "antd";

import Index from "./version/index";
import FetchCSVData from "./version/task";
const { TabPane } = Tabs;

const Version = ({ auth }) => {
  const onChange = (key) => {
  };
  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        {/* <Breadcrumb.Item>Dashboard</Breadcrumb.Item> */}
      </Breadcrumb>
      <div className="site-layout-background main-frame">
        <Tabs defaultActiveKey="1" onChange={onChange}>
          <TabPane tab="Task List" key="1">
            <FetchCSVData />
          </TabPane>
          <TabPane tab="Version" key="2">
            <Index />
          </TabPane>
        </Tabs>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(Version);
